export default "__VITE_ASSET__Du_tzPbf__"